module.exports = __webpack_public_path__ + "static/media/kozamgi_rwamiko7.1b40cde6.jpg";